import { BannerAction } from './types';

export interface ResolveBannerActionParams {
  isEnabled: boolean;
  isNonFaUwEnabled: boolean;
  showUnderwriterUi: boolean;
  isTitleMonitoring: boolean;
}

export function resolveBannerAction({
  isEnabled,
  isNonFaUwEnabled,
  showUnderwriterUi,
  isTitleMonitoring,
}: ResolveBannerActionParams): BannerAction {
  if (!isEnabled) {
    return showUnderwriterUi ? BannerAction.OtherUnderwritersEnable : BannerAction.DirectEnable;
  }

  if (!isNonFaUwEnabled) {
    return BannerAction.DisableConfirm;
  }

  if (isTitleMonitoring) {
    return BannerAction.DisableConfirm;
  }

  if (showUnderwriterUi) {
    return BannerAction.OtherUnderwritersDisable;
  }

  return BannerAction.DisableConfirm;
}
